import { useQuestionnaireNavigation } from '@/context/NavigationProvider';
import { Button } from '@/components/ui/button';
import Info1Pic from '@/assets/Onboarding/BlignyInfo1Pic.png';
import { PatientPageLayout } from '@/components/PatientPageLayout';

export const BlignyIntro1Page = () => {
  const { navigateNext } = useQuestionnaireNavigation();

  return (
    <PatientPageLayout
      title={
        <h1 className="text-2xl min-[23rem]:text-3.5xl font-semibold leading-tight nxs:text-center">
          Donnez le plus de <br /> détails possible !
        </h1>
      }
      contentClassName="flex flex-col items-center justify-center nxs:text-center"
      footer={
        <div className="flex w-full flex-col items-center mx-auto">
          <Button variant="ctaPrimary" size="lg" onClick={navigateNext}>
            Continuer
          </Button>
        </div>
      }
    >
      <div className="flex flex-col items-center gap-5 max-w-86 text-center">
        <img src={Info1Pic} alt="Jeune fille qui écrit" />
        <p className="leading-5 font-light">
          Chaque réponse aide à mieux comprendre votre situation. Si vous ne
          savez pas quoi répondre, passez simplement à la question suivante.
        </p>
      </div>
    </PatientPageLayout>
  );
};
